<template>
    <div v-if="options">
        <div
            :style="headerHeight"
            class="site-header sticky h-100"
        >
            <slot name="debugging" />
            <div class="container grid-x h-100">
                <div
                    :class="logoClasses"
                    class="cell h-100 bbb"
                >
                    <logo-header
                        :options="options"
                        class="h-100"
                    />
                </div>
                <div
                    v-if="isScrolled"
                    ref="leftHeaderContainerScrolled"
                    :class="leftClasses"
                    class="cell h-100 padding-top grid-x align-justify"
                >
                    <transition
                        name="logo-fade"
                        mode="in-out"
                    >
                        <div
                            v-if="isScrolled"
                            key="scrolled"
                            class="cell auto grid-x align-center"
                        >
                            <div
                                class="cell shrink top-menu-container "
                            >
                                <top-menu
                                    ref="topMenu"
                                    :options="options"
                                    class="align-left margin-left"
                                />
                            </div>
                        </div>
                    </transition>
                    <div
                        :class="functionMenuClases"
                        class="function-menu-container"
                    >
                        <function-menu
                            :options="options"
                        />
                    </div>
                </div>
                <div
                    v-if="!isScrolled"
                    ref="leftHeaderContainerScrolled"
                    :class="leftClasses"
                    class="cell h-100 padding-top grid-y align-justify"
                >
                    <div
                        :class="functionMenuClases"
                        class="function-menu-container"
                    >
                        <function-menu
                            :options="options"
                        />
                    </div>
                    <transition

                        name="logo-fade"
                        mode="out-in"
                    >
                        <div
                            v-if="!isScrolled && large"
                            key="notScrolled"
                            class="cell top-menu-container unscrolled-top-menu"
                        >
                            <top-menu
                                ref="topMenu"
                                :options="options"
                                class="grid-x align-right"
                            />
                        </div>
                    </transition>
                </div>
            </div>
        </div>
        <search-bar
            v-if="options.SearchPageLink && options.EnableSearch"
            :field-placeholder-text="options.SearchBarPlaceholder"
            :search-page-url="options.SearchPageLink.Url"
        />
        <mega-menu-large-screen
            :is-autenticated="options.IsAuthenticated"
            :header-top-menu-element-models="options.HeaderTopMenuElementModels"
        />
    </div>
</template>
<script>
import FunctionMenu from '../FunctionMenu.vue';
import HeaderBaseMixinVue from '../HeaderBaseMixin.vue';
import SearchBarVue from '../../Search/SearchBar.vue';

import LogoHeader from '../LogoHeader.vue';
import TopMenu from './TopMenu.vue';
import MegaMenuLargeScreenVue from './MegaMenuLargeScreen.vue';

export default {
    name: 'SiteHeaderLargeScreen',
    components: {
        'logo-header': LogoHeader,
        'function-menu': FunctionMenu,
        'top-menu': TopMenu,
        'mega-menu-large-screen': MegaMenuLargeScreenVue,
        'search-bar': SearchBarVue
    },
    mixins: [
        HeaderBaseMixinVue
    ],
    props: {
        options: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            leftContainerClasses: 'grid-y',
            topMenuClasses: '',
            functionMenuClases: '',
            hideTopMenu: true,
            stickyOverlay: ''
        };
    },
    computed: {
        headerHeight() {
            return {
                height: `${this.$store.state.header.height}px`
            };
        },
        isScrolled() {
            return this.$store.state.header.isScrolled;
        },
        logoClasses() {
            return {
                'small-4': !this.isScrolled,
                'small-3': !this.options.IsAuthenticated && this.isScrolled,
                'small-2': this.options.IsAuthenticated && this.isScrolled
            };
        },
        leftClasses() {
            return {
                'small-8': !this.isScrolled,
                'small-9': !this.options.IsAuthenticated && this.isScrolled,
                'small-10': this.options.IsAuthenticated && this.isScrolled
            };
        }
    },
    watch: {
        '$store.state.header.scrollY': function (val) {
            this.$store.commit('header/setIsScrolled', val !== 0);
        },

        '$store.state.header.height': function () {
            this.hideTopMenu = false;

            setTimeout(() => {
                this.hideTopMenu = true;
            }, 400);
        }
    },
    created() {
    },
    updated() {
        if (this.$parent && this.$parent.$el) {
            this.stickyOverlay = `height: ${this.$parent.$el.clientHeight}px`;
        }
    }
};
</script>
<style lang="scss" scoped>
@import '../header';

.container {
    &.transition {
        transition: height $header-animation-time linear;
    }
}

.site-header{
    transition: height $header-animation-time linear;
}

.h-100 {
    height: 100%;
}

.padding-bottom {
    padding-bottom: $header-gutter-bottom;
}

.padding-top {
    padding-top: $header-gutter-bottom;
}

.ease-tansition-width {
    transition: all $header-animation-time linear;
}

.sticky-overlay {
    height: 100vh;
}

.unscrolled-top-menu {
    position: absolute;
    bottom: 0;
    right: $container-gutter;
}

.container-gutter-right {
    padding-right: $container-gutter;
}

.margin-left {
    margin-left: 15px;
}

.max-content {
    width: max-content;
}

.logo-fade-enter-active {
  transition: opacity .5s;
}

 .logo-fade-leave-active {
  opacity: 0;
}

.logo-fade-enter, .logo-fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

</style>
